module.exports = __webpack_public_path__ + "static/logo-redsatelliteradio-327b5c9d210f88a2c18dda486a9431df.jpg";